<template>
  <el-dialog
    :visible="visible"
    :append-to-body="appendToBody"
    center
    custom-class="order-form-send-order-dialog"
    @update:visible="$emit('update:visible', $event)"
    @closed="$emit('closed')"
  >
    <span class="dialog-text">注文を送信しますか？</span>
    <OrderFormExpectedShippingDatePicker
      v-if="showExpectedShippingPicker"
      ref="expectedShippingPicker"
    />
    <span slot="footer" class="dialog-footer">
      <el-button
        class="cancel-btn"
        @click="onCancel"
      >
        キャンセル
      </el-button>
      <el-button
        class="blue-text"
        :disabled="submitDisabled"
        :loading="submitLoading"
        @click="onSubmit"
      >
        送信する
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import OrderFormExpectedShippingDatePicker from "@/components/OrderFormExpectedShippingDatePicker.module";

export default {
  name: "OrderFormSendOrderDialog",
  components: {
    OrderFormExpectedShippingDatePicker,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    appendToBody: {
      type: Boolean,
      default: false,
    },
    showExpectedShippingPicker: {
      type: Boolean,
      default: true,
    },
    submitDisabled: {
      type: Boolean,
      default: false,
    },
    submitLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onCancel () {
      this.$emit("cancel");
    },
    onSubmit () {
      if (
        this.showExpectedShippingPicker &&
        this.$refs.expectedShippingPicker &&
        !this.$refs.expectedShippingPicker.validateInput()
      ) {
        return;
      }
      this.$emit("submit");
    },
  },
};
</script>

<!-- OrderFormStep7 #OrderRequest 内の注文送信モーダルと同一の見た目 -->
<style lang="scss">
@import "~@/assets/styles/variables.scss";

.order-form-send-order-dialog .dialog-text {
  font-size: 17px;
  font-weight: bold;
}
.order-form-send-order-dialog.el-dialog--center .el-dialog__body {
  text-align: center;
  padding-bottom: 5rem;
  padding-top: 5rem;
  margin-top: 1rem;
}
.order-form-send-order-dialog .el-button {
  border: none;
}
.order-form-send-order-dialog .el-dialog__close {
  display: none;
}
.order-form-send-order-dialog .blue-text {
  color: $blue-extra-deep;
}
.order-form-send-order-dialog .blue-text.is-disabled {
  color: $--color-text-placeholder;
  border-color: $--border-color-lighter;
}
.order-form-send-order-dialog .el-dialog__footer {
  margin-left: 10%;
}
</style>
